import { db } from '@/services/storage/db';
import { deletePhotosForHarvest } from './photo-service';
import { posthogService } from '@/services/posthog-service';
import { EVENT_HARVEST_RECORDED } from '@/services/observability/events';
import type { HarvestRecord } from '@/types/hunt';

export async function getHarvestRecordsByHunt(huntId: string): Promise<HarvestRecord[]> {
  return db.getHarvestRecordsByHunt(huntId);
}

export async function getHarvestRecordsBySeason(huntIds: string[]): Promise<HarvestRecord[]> {
  const all = await Promise.all(huntIds.map((id) => db.getHarvestRecordsByHunt(id)));
  return all.flat();
}

export async function createHarvestRecord(record: HarvestRecord): Promise<HarvestRecord> {
  const result = await db.createHarvestRecord(record);
  posthogService.track(EVENT_HARVEST_RECORDED);
  return result;
}

export async function updateHarvestRecord(
  id: string,
  updates: Partial<HarvestRecord>,
): Promise<HarvestRecord> {
  return db.updateHarvestRecord(id, updates);
}

/**
 * Delete a harvest record and all its attached photos.
 * Photo deletion runs first — if it throws, the harvest record is NOT deleted.
 */
export async function deleteHarvestRecord(id: string): Promise<void> {
  await deletePhotosForHarvest(id);
  return db.deleteHarvestRecord(id);
}
